module.exports = __webpack_public_path__ + "static/media/logoheader.4dfc1e7d.png";